import translations from 'services/translations/translations';
import getOptions from '../services/getOptions';
import woodyQuantityDecorlist from './woodyQuantityDecorlist';
import woodyWallProfileHeightTypes from './woodyWallProfileHeightTypes';

export const woodyWallProfileHeightOptions = (): JSX.Element[] =>
  getOptions(
    woodyWallProfileHeightTypes,
    translations.woodyWallProperties,
    'woodyProfileHeightTypes'
  );

export const woodyQuantityDecorlistOptions = (): JSX.Element[] =>
  getOptions(
    woodyQuantityDecorlist,
    translations.woodyWallProperties,
    'decorListQty'
  );
